import React, { useState, useEffect, useRef } from 'react';

import ProductCard from '../components/ProductCard';
import { supabase } from '../supabaseClient';
import { routes } from '../routes';

const HomePage = ({ onAddToCart, onProductClick, onNavigate }) => {
  const [products, setProducts] = useState([]);
  // ⬇️ NUEVO: estados en vez de arrays fijos
  const [featuredIds, setFeaturedIds] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);

  const featuredProducts = products.filter((product) => featuredIds.includes(product.id));

  // Productos (igual que antes)
  useEffect(() => {
    const fetchProducts = async () => {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error al obtener productos:', error);
      } else {
        setProducts(data || []);
      }
    };

    fetchProducts();
  }, []);

  // ⬇️ NUEVO: leer assets (carousel + destacados) desde una sola tabla
  useEffect(() => {
    const fetchAssets = async () => {
      const { data: assets, error } = await supabase
        .from('site_assets')
        .select('kind, ref_value, position, active, starts_at, ends_at')
        .eq('active', true)
        .order('position', { ascending: true });

      if (error) {
        console.error('Error al obtener site_assets:', error);
        return;
      }

      const now = new Date();
      const inSchedule = (row) => {
        const startOk = !row.starts_at || new Date(row.starts_at) <= now;
        const endOk = !row.ends_at || new Date(row.ends_at) >= now;
        return startOk && endOk;
      };

      const filtered = (assets || []).filter(inSchedule);

      const imgs = filtered
        .filter(a => a.kind === 'carousel_image')
        .map(a => a.ref_value);

      const feats = filtered
        .filter(a => a.kind === 'featured_product')
        .map(a => Number(a.ref_value))
        .filter(Number.isFinite);

      setCarouselImages(imgs);
      setFeaturedIds(feats);
    };

    fetchAssets();
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const nextSlide = () => {
    setCurrentImageIndex((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? carouselImages.length - 1 : prev - 1));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    handleSwipe();
  };

  const handleSwipe = () => {
    const distance = touchStartX.current - touchEndX.current;
    const threshold = 50;

    if (distance > threshold) nextSlide();
    else if (distance < -threshold) prevSlide();
  };

  // Autoplay (igual, pero esperando a tener imágenes)
  useEffect(() => {
    if (!carouselImages.length) return;
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [carouselImages]);

  return (
    <div className="w-full">
      {/* Carrusel con animación deslizante y soporte táctil */}
      <div
        className="relative w-full overflow-hidden shadow-lg mb-12"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
        >
          {carouselImages.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`slide-${index}`}
              className="w-full flex-shrink-0 object-cover"
              style={{ minWidth: '100%' }}
            />
          ))}
        </div>

        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
          {carouselImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`h-3 w-3 rounded-full ${
                currentImageIndex === index ? 'bg-white' : 'bg-gray-400'
              } transition-colors`}
            ></button>
          ))}
        </div>
      </div>

<div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-20 mb-16">
  <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-stretch">
    {/* Imagen grande */}
    <div
      data-aos="fade-up-right"
      data-aos-duration="1000"
      className="xl:col-span-2 shine" 
    >
      <a href="https://elancla.store/search/audifono">
        <img
          src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//bannertrio1.webp"
          alt=""
          className="w-full h-full object-cover rounded-xl shadow-sm "
        />
      </a>
    </div>

    {/* Columnas pequeñas alineadas perfectamente */}
    <div className="flex flex-col justify-between gap-6 " >
      <div data-aos="fade-up-left" data-aos-duration="1000" className='shine'>
        <a href="https://elancla.store/search/parlante">
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//bannertrio2.webp"
            alt=""
            className="w-full h-full object-cover rounded-xl shadow-sm "
          />
        </a>
      </div>
      <div data-aos="fade-up-left" data-aos-delay="200" data-aos-duration="1000" className='shine'>
        <a href="https://elancla.store/search/toca%20discos">
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//bannertrio3.webp"
            alt=""
            className="w-full h-full object-cover rounded-xl shadow-sm "
          />
        </a>
      </div>
    </div>
  </div>
</div>



  
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      
<section className="mb-20">
  <div className="container mx-auto px-4">
    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-10 text-center">
      Explora Nuestras Categorías
    </h2>
    <div className="flex flex-col md:flex-row justify-center items-center gap-10">
      {/* Banner Perfumes */}
      <div
        data-aos="fade-up"
        data-aos-duration="800"
        className=" shine w-[90%] sm:w-[300px] md:w-[400px] lg:w-[500px] aspect-square rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-transform duration-300 hover:scale-105"
      >
        <a href={routes.perfumes} className="block w-full h-full">
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//perfumescat.png"
            alt="Perfumes"
            className="w-full h-full object-cover"
          />
        </a>
      </div>

      {/* Banner Tecnología */}
      <div
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="800"
        className="shine w-[90%] sm:w-[300px] md:w-[400px] lg:w-[500px] aspect-square rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-transform duration-300 hover:scale-105"
      >
        <a href={routes.tecnologia} className="block w-full h-full">
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//techcat.png"
            alt="Tecnología"
            className="w-full h-full object-cover"
          />
        </a>
      </div>
    </div>
  </div>
</section>




        {/* Sección de Productos Destacados */}
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 text-center">Productos Destacados</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-6">
          { featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} onAddToCart={onAddToCart} onProductClick={onProductClick} />
          ))}
        </div>
<br className="my-12" />
        {/* Banner Promocional Ancho */}
<section className="w-full mb-[60px]">
  <div className="container mx-auto px-4">
    <div className="shine overflow-hidden">
      <div data-aos="fade-right" className="w-full">
        
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//banner-4.png"
            alt="Promoción destacada"
            className="w-full h-auto sm:h-full object-cover rounded-xl shadow-md"
          />
        
      </div>
    </div>
  </div>
</section>

      </div>
    </div>
  );
};

export default HomePage;
